// @flow
import React from 'react';
import Loader from '../../ressources/animations/gif/loader.gif'

const BILLoader = () => {

    return (
        <div>
            <img src={Loader} alt={'Bil loader'} style={{width: '350px', height: '350px'}} />
        </div>
    )
};

export default BILLoader;